import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';

// material
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  CircularProgress,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
  FormControl,
  Select,
  Icon,
  Box,
  Container,
  Typography,
  MenuItem,
  TableContainer,
  TablePagination,
  TextField,
} from '@mui/material';
import axios from 'axios';
import CopyToClipboard from 'react-copy-to-clipboard';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import { toast } from 'react-toastify';
import { LoadingButton } from '@mui/lab';
import Iconify from './Iconify';
import Scrollbar from './Scrollbar';

import Popup from './PopupPaymentStatus';
import DeliveryPopup from './PopupDeliveryStatus';
import RefundPopup from './PopupRefundStatus';
import { ReturnOrderFilter } from './ReturnOrderFilter';

export default function Returned({status}) {
  const [isLoading, setIsLoading] = useState(true);
  const [pages, setPages] = useState(0);
  const [orderCount, setOrderCount] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [orderData, setOrderData] = useState({});
  const [filters, setFilters] = useState({ size: 10, page: 0 , returnStatus: status});
  const size = 10;

  const getOrderData = async (filters) => {
    try {
      setIsLoading(true);
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/order/admin/return-all`, { params: filters });
      console.log('orders', res);
      setOrderData(res.data.data.records);
      setOrderCount(res.data.data.maxRecords);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handlePageChange = (event, newPage) => {
    const temp = { ...filters, page: newPage };
    setFilters(temp);
    setPages(newPage);
    getOrderData(temp);
  };

  const applyFilters = (filter) => {
    console.log('bfilter', filter);
    const temp = {size: 10, page: 0 , returnStatus: status};
    if (filter.userId.length) {
      temp.userId = filter.userId;
    }
    if (filter.invoiceNumber.length) {
      temp.invoiceNumber = filter.invoiceNumber;
    }
    if (filter.courierId.length) {
      temp.courierId = filter.courierId;
    }
 
    if (filter.deliveryStatus.length) {
      temp.deliveryStatus = filter.deliveryStatus;
    }

    if (filter.refundStatus.length) {
      temp.refundStatus = filter.refundStatus;
    }
    if (filter.startDate) {
      temp.startDate = filter.startDate;
    }
    if (filter.endDate) {
      temp.endDate = filter.endDate;
    }
    setFilters(temp);
    setPages(0);
    getOrderData(temp);
  };

  useEffect(() => {
    getOrderData(filters);
  }, []);

  return (
    <div>
      {isLoading ? (
        <div
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '50vh',
          }}
        >
          <CircularProgress />
        </div>
      ) : (
        <Card>
          <Stack direction="row" alignItems="center" justifyContent={'flex-end'} p={2}>
            <ReturnOrderFilter applyFilters={applyFilters} /> 
          </Stack>
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                {/* <UserListHead /> */}
                <TableHead>
                  <TableRow>
                    <TableCell>Sl No</TableCell>
                    {/* <TableCell>ID</TableCell> */}
                    <TableCell>Invoice Number</TableCell>
                    <TableCell>User ID</TableCell>
                    <TableCell>Return Status</TableCell>
                    <TableCell> Created On</TableCell>
                    <TableCell> Updated On </TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {orderData?.map((item, id) => (
                <TableRow key={id} sx={{ '&:hover': { backgroundColor: '#fff0ed' } }}>
                      <TableCell>{pages * size + (id + 1)}</TableCell>
                      {/* <TableCell style={{ wordBreak: 'break-all' }}>{item._id}</TableCell> */}
                      <TableCell style={{ cursor: 'pointer', width: '100px', wordBreak: 'break-all' }}>
                        <Stack direction="column" spacing={0.5} width="100px">
                          <CopyToClipboard text={item.invoiceNumber} onCopy={() => toast.info('Invoice number copied')}>
                            <Typography>{item.invoiceNumber}</Typography>
                          </CopyToClipboard>
                        </Stack>
                      </TableCell>
                      <TableCell style={{ cursor: 'pointer', width: '100px' }}>
                        <Stack direction="column" spacing={0.5} width="100px">
                          <Link
                            style={{ textDecoration: 'none', color: 'inherit' }}
                            to={`/dashboard/user/${item.userId}`}
                          >
                            <Stack direction="row" alignItems="center" spacing={0.5} justifyContent="flex-start">
                              <Iconify icon="gg:user-list" style={{ height: '18px', width: '18px', color: 'green' }} />
                              <Typography sx={{ color: 'green' }} variant="p">
                                View
                              </Typography>
                            </Stack>
                          </Link>
                          <CopyToClipboard text={item.userId} onCopy={() => toast.info('User id copied')}>
                            <Stack direction="row" alignItems="center" spacing={0.5} justifyContent="flex-start">
                              <Iconify
                                icon="lucide:clipboard-copy"
                                style={{ height: '18px', width: '18px', color: '#cb4d4d' }}
                              />
                              <Typography sx={{ color: '#cb4d4d' }} variant="p">
                                Copy ID
                              </Typography>
                            </Stack>
                          </CopyToClipboard>
                        </Stack>
                      </TableCell>

                      <TableCell>{item.returnStatus}</TableCell>

                      <TableCell>{moment(item.createdAt).format('MMMM DD, YYYY')}</TableCell>
                      <TableCell>{moment(item.updatedAt).format('MMMM DD, YYYY')}</TableCell>
                      <TableCell>
                        <Box>
                          <Link to={`/dashboard/order/${item._id}`}>
                            <Icon sx={{ color: 'gray' }}>
                              <RemoveRedEyeOutlinedIcon />
                            </Icon>
                          </Link>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Scrollbar>
          <TablePagination
            rowsPerPageOptions={[]}
            component={'div'}
            count={orderCount}
            showFirstButton
            showLastButton
            onPageChange={handlePageChange}
            rowsPerPage={rowsPerPage}
            page={pages}
          />
        </Card>
      )}
    </div>
  );
}
